import faqsConfig from "../../config/faqs&Resourse/faqsConfig";
import { apiService } from "../apiService";
import urlConfig from "../../config/domain";

export const getFaqs = (callback) => {
  apiService(
    {
      url: faqsConfig.getFaqs,
      method: "GET",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      // source: sessionStorage.getItem("source") || undefined,
      // sourcetoken: sessionStorage.getItem("sourceToken") || undefined,
    },
    callback
  );
};

export const getFaqsById = (callback, tabid) => {
  apiService(
    {
      url: faqsConfig.getFaqsById + `?tabId=${tabid}`,
      method: "GET",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      // source: sessionStorage.getItem("source") || undefined,
      // sourcetoken: sessionStorage.getItem("sourceToken") || undefined,
    },
    callback
  );
};

export const getFaqsBySearch = (callback, body) => {
  apiService(
    {
      url: faqsConfig.getFaqsBySeacrh,
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      // source: sessionStorage.getItem("source") || undefined,
      // sourcetoken: sessionStorage.getItem("sourceToken") || undefined,
      body,
    },
    callback
  );
};
